module.exports = __webpack_public_path__ + "img/symbol_amor@2x.8448421.webp";